import Vue from 'vue';
import Vuex from 'vuex';
import { ElementApiModule } from 'clockvine-vue';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        resources: new ElementApiModule('/resources.json', { debounce: 1000 }),
        resourceTypes: new ElementApiModule('/resourceTypes.json', { debounce: 1000 }),
        dealers: new ElementApiModule('/dealers.json', { debounce: 1000 }),
        dealerCountries: new ElementApiModule('/dealerCountries.json', { debounce: 1000 }),
        dealerStates: new ElementApiModule('/dealerStates.json', { debounce: 1000 }),
        events: new ElementApiModule('/events.json', { debounce: 1000 }),
        newsItems: new ElementApiModule('/news.json', { debounce: 1000 }),
        blogPosts: new ElementApiModule('/blogs.json', { debounce: 1000 }),
        blogSolutions: new ElementApiModule('/blogSolutions.json', { debounce: 1000 }),
        blogProducts: new ElementApiModule('/blogProducts.json', { debounce: 1000 }),
    },
});
